import { useState } from 'react';

import MobileDrawer from '@components/shared/MobileDrawer';
import { componentLoader } from '@utils/componentLoader';

import { buildHeaderLinks } from './layoutLinks';

const Header = componentLoader('Header');
const navItems = buildHeaderLinks();

const LayoutHeader = () => {
  const [isMobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const toggleMobileDrawer = () => {
    setMobileDrawerOpen(!isMobileDrawerOpen);
  };

  return (
    <>
      <Header isMobileDrawerOpen={isMobileDrawerOpen} navItems={navItems} toggleMobileDrawer={toggleMobileDrawer} />
      <div>{navItems.length > 0 && <MobileDrawer isOpen={isMobileDrawerOpen} navItems={navItems} onClose={toggleMobileDrawer} />}</div>
    </>
  );
};

export default LayoutHeader;
